// ScrollToHashElement.tsx
import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {onRequestsIdle} from "./cms/factory";

const ScrollToHashElement: React.FC<{ offset?: number }> = ({offset = 80}) => {
    const {hash} = useLocation();

    useEffect(() => {
        if (!hash) return;
        const el = document.querySelector(hash);
        if (!el) return;

        const scrollToTarget = () => {
            const y = el.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({top: y, behavior: "smooth"});
        };

        scrollToTarget();

        const unsubscribe = onRequestsIdle(() => {
            scrollToTarget();
        });
        return () => unsubscribe();
    }, [hash, offset]);

    return null;
};

export default ScrollToHashElement;
